interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, subtitle, align = 'left' }: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return (
    <div className={`flex flex-col ${alignment} gap-3`}>
      <span className="inline-flex items-center gap-2 font-label text-xs md:text-sm font-medium tracking-widest uppercase text-primary-600">
        <span className="w-6 h-px bg-primary-400" aria-hidden="true" />
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">{title}</h2>
      {subtitle ? (
        <p className={`text-sm md:text-base text-foreground-600 leading-relaxed ${align === 'center' ? 'max-w-2xl' : 'max-w-2xl'}`}>
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}